import React from 'react'

export function ForbiddenCircleOutlineIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}>
      {/* Icon from Solar by 480 Design - https://creativecommons.org/licenses/by/4.0/ */}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75S22.75 17.937 22.75 12S17.937 1.25 12 1.25M2.75 12A9.25 9.25 0 0 1 12 2.75c2.284 0 4.376.828 5.99 2.2l-.02.02l-13 13l-.02.02A9.2 9.2 0 0 1 2.75 12m3.26 7.05A9.25 9.25 0 0 0 19.05 6.01l-.019.02l-13 13z"
        clipRule="evenodd"
      />
    </svg>
  )
}
